const buttonFadeDurationMs = 100;
const wrapper = "_35swbhlqpv";
const chevron = "_35scboiqqd";
const container = "_35sc1vg8mtg";
const scrollButton = "_35ssdzf2aw";

export { buttonFadeDurationMs, chevron, container, scrollButton, wrapper };
import "./container.input.style.linaria.module.css";
//# sourceMappingURL=container.input.style.js.map
